import { gql } from "@apollo/client"

export const CREATE_DISTRICT = gql`
  mutation createDistrict($data: DistrictCreateInput) {
    district {
      createDistrict(data: $data)
    }
  }
`

export const UPDATE_DISTRICT = gql`
  mutation updateDistrict($data: DistrictUpdateInput) {
    district {
      updateDistrict(data: $data)
    }
  }
`

export const DELETE_DISTRICTS = gql`
  mutation deleteDistricts($data: DistrictIdsListInput) {
    district {
      removeBatch(data: $data)
    }
  }
`
